<template>
  <div class="sign-in">
    <button class="button sign-in-button" v-on:click="signIn()" v-if="!isSignedIn">Sign in</button>

    <div class="select-room" v-if="isSignedIn">
      <label class="select-room__label" for="select-room__selector">Which room?</label>
      <select id="select-room__selector" class="select-room__selector" v-model="calendarId" v-on:change="$emit('calendar-id-selected', calendarId)">
        <option v-for="calendar in availableCalendars" :key="calendar.id" :value="calendar.id">{{ calendar.summary }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import ButtonSoundMixins from './ButtonSoundMixins.vue';

export default {
  name: 'SignIn',
  mixins: [ButtonSoundMixins],
  props: {
    gCalApi: Object,
    isSignedIn: Boolean
  },
  data: function() {
    return {
      calendarId: null,
      availableCalendars: []
    }
  },
  watch: {
    isSignedIn: function() {
      if(this.isSignedIn) {
        this.fetchCalendars();
      }     
    }
  },
  methods: {
    signIn: function() {
      this.playButtonSound();
      this.gCalApi.auth2.getAuthInstance().signIn();      
    },
    fetchCalendars: function() {
      const app = this;
      this.gCalApi.client.calendar.calendarList.list()
        .then(function(response) {
          app.availableCalendars = response.result.items.filter((c) => c.summary.includes('15 Adam Street'));
        }); 
    }
  },
  mounted: function() {
    if(this.isSignedIn) {
      this.fetchCalendars();
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/components/colours';
@import '../styles/components/mixins';

.sign-in {
  background: $green;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.sign-in-button {
  @include vertically-centred;   
  font-size: 15em;
}

.select-room {
  @include vertically-centred;
  width: 100%;

  &__label {
    display: block;
    font-size: 15em;
    font-weight: bold;
    text-align: center;
  }

  &__selector {
    margin: 0 auto;
    display: block;
    font-size: 15em;
    max-width: 80%;

    option {
      font-size: 12pt;
    }
  }
}
</style>